import React, { useEffect } from "react";
import "./bootstrap.min.css";
import "./App.css";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import HeaderSection from "./components/header/header";
import HomePage from "./pages/home";
import FooterComponent from "./components/footer/footer";
import AboutusPage from "./pages/aboutus";
import IndustriesPage from "./pages/industriesweserve";
import ContactusPage from "./pages/contactus";
import FittingComponents from "./pages/fittingcomponants";
import EarthingComponents from "./pages/earthingcomponents-page";
// import PprinsertsComponents from "./pages/pprinserts";
import $ from 'jquery'
import MechanicalComponents from "./pages/mechanical";
import PlasticComponents from "./pages/plasticcomponents";


function App() {
  // useEffect(() => {
  //   $(".mob-menu").click(() => {
  //     $('.nav').fadeIn();
  //   }); 
  //   if($(window).width()<767){
  //     $('.nav .nav-item').click(()=>{
  //       $('.nav').fadeOut();
  //     })
  //   }   
  // });
  // const location = useLocation();
  return (
      <>
        <HeaderSection />
        <Route path="/" exact component={HomePage}></Route>
        <Route path="/home" exact component={HomePage}></Route>
        <Route path="/about-us" exact component={AboutusPage}></Route>
        <Route path="/industries-we-serve" exact component={IndustriesPage}></Route>
        <Route path="/contact-us" exact component={ContactusPage}></Route>
        <Route path="/fittingcomponents" exact component={FittingComponents}  ></Route>
        <Route path="/earthingcomponents" exact component={EarthingComponents}  ></Route>
        <Route path="/mechanicalcomponents" exact component={MechanicalComponents}  ></Route>
        <Route path="/plasticcomponents" exact component={PlasticComponents}  ></Route>
        
        <FooterComponent />
      </>
  );
}

export default App;
